export function kmToMiles(value: string | number): number {
  if (value === 0 || value === '0') {
    return 0;
  }
  if (!value) {
    return null;
  }
  const km: number = typeof value === 'string' ? Number(value) : value;
  return Math.round(km / 1.609344);
}
